import { createPaginatedSlice } from '../../../helpers/reduxHelper';

const paginatedImagineAI = createPaginatedSlice('paginatedImagineAI');

export const paginatedImagineAIActions = paginatedImagineAI.actions;
export const paginatedImagineAISelector = (state) => state.imagineAIImages;
export const paginatedImagineAIReducer = paginatedImagineAI.reducer;
export default paginatedImagineAIReducer;

export const paginatedImagineAISelectors = paginatedImagineAI.LF.selectors;
